import React from "react"
import CalendarTutorial from "../../components/calendar-tutorial"

const tutorial = {
  quickAnswer: {
    question: "Do edits automatically update the shared calendar?",
    answer:
      "No. Editing the original calendar does not change the published view. Use Republish to update the same read-only link, then ask viewers to reopen or refresh it. Tell families separately about important changes; republishing does not send notifications.",
  },
  title: "Publish and Share Your Calendar",
  description:
    "Publish a read-only School Calendar, optionally protect it with a password, and republish updates using the same URL.",
  intro:
    "Give families one place to check your schedule. Publish a read-only view, test the link, and republish when arrangements change.",
  rows: [],
  prompt: "",
  steps: [
    {
      title: "1. Review the calendar",
      paragraphs: [
        "Open the calendar you want to share. Check its title, description, event dates, times, and details so viewers have the information they need.",
      ],
    },
    {
      title: "2. Publish the read-only view",
      paragraphs: [
        "Select Publish calendar and review the information that viewers will see. If you want viewers to enter a password, fill in Optional password before selecting Publish.",
        "The published view is read-only. Viewers can check the schedule without changing the calendar you maintain.",
      ],
    },
    {
      title: "3. Test and share the link",
      paragraphs: [
        "Copy the published URL and open it in another browser or on your phone. Check the schedule and, if you set a password, confirm that the password prompt appears and the password opens the view.",
        "Share the URL through your usual family, classroom, or club communication channel. Provide the password to the intended viewers if you set one.",
      ],
    },
    {
      title: "4. Republish changes",
      paragraphs: [
        "Edit the original calendar when a date, time, or event detail changes. Check the updated plan, open Publish calendar, and select Republish.",
        "The published URL stays the same. Viewers can reopen or refresh it to see the updated schedule. Republishing does not send an automatic notification, so communicate important changes through your usual channel.",
      ],
    },
  ],
  cta: "Publish your calendar",
  relatedUrl: "/how-to-guides/move-calendar-events-with-chat/",
  relatedTitle: "Move Your Calendar Events with One Chat Request",
}

export default function GuidePage() {
  return <CalendarTutorial {...tutorial} />
}
